import * as React from 'react';

// eslint-disable-next-line @gandi/gandi/no-private-import

import createFocusDecorator from 'final-form-focus';
import { Form as FinalForm } from 'react-final-form';
import { jsx as _jsx } from "react/jsx-runtime";
// $FlowFixMe[unclear-type]
const EMPTY_ARRAY = [];
const focusOnErrors = createFocusDecorator();

/**
 * Syntaxic sugar with form provider
 *
 * XXX: Generic type is not super useful in jsx. For now it provides better type than any in FormProps.
 */
export function FormProvider(finalFormProps) {
  const {
    decorators = EMPTY_ARRAY,
    ...extraFinalFormProps
  } = finalFormProps;
  const decoratorsMemoized = React.useMemo(() => [...decorators, focusOnErrors],
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [...decorators]);
  return (
    /*#__PURE__*/
    // $FlowFixMe[prop-missing] FinalForm's FormProps definition isn't compatible with exact_by_default
    _jsx(FinalForm, {
      decorators: decoratorsMemoized,
      ...extraFinalFormProps
    })
  );
}